module.exports = __webpack_public_path__ + "static/media/TradllyGroup.37cca7a2.svg";